<script>
  import UploadFiles from '../../components/UploadFiles.svelte';
  import FormInput from '../../components/FormControls/FormInput.svelte';

  import SimpleFileUploader from '../../components/SimpleFileUploader.svelte';
  import { getContext } from 'svelte';
  import { searchKeyByValue, addHttpIfNot, validURL } from 'components/Helper.js';

  export let form;
  export let errors;
  export let handleChange;

  const showDialog = getContext('showDialog');

  const removeUrl = (key) => {
    let arr = $form.urls;
    arr.splice(key, 1);
    $form.urls = arr;

    let errorArr = $errors.urls;
    errorArr.splice(key, 1);
    $errors.urls = errorArr;
  };
  let displayfiles = $form.attachments;
  export let setIsFormPending;

  let urlInvalid = '';
  let newUrl = '';
  let newTitle = '';
  const addUrl = () => {
    if (newUrl != '') {
      if (validURL(newUrl)) {
        let oldUrls = $form.urls;
        oldUrls.push({ title: newTitle, url: addHttpIfNot(newUrl) });
        $form.urls = oldUrls;
        newUrl = '';
        newTitle = '';
        urlInvalid = false;
      } else {
        urlInvalid = 'Invalid Url';
      }
    } else {
      urlInvalid = 'Required';
    }
  };
</script>

<div class="p-3 h-100">
  <div class="profile-content mx-auto">
    <div class="block-title mb-4">
      <h3 class="mt-0 title"><span>Links/Attachments</span></h3>
    </div>
  </div>
  <div class="profile-content mx-auto h-100">
    <div class="form-group mb-3">
      <div class="row">
        <div class="col-md-12">
          <!-- <UploadFiles /> -->
          <SimpleFileUploader
            on:fileChanged={(event) => {
              if (event.detail.type == 'add') {
                $form.attachments.push(event.detail);
              } else if (event.detail.type == 'delete') {
                let index = searchKeyByValue($form.attachments, 'fileName', event.detail.fileName);
                if (index !== -1) {
                  $form.attachments.splice(index, 1);
                }
              } else if (event.detail.type == 'uploading') {
                setIsFormPending(true);
              } else if (event.detail.type == 'uploaded') {
                setIsFormPending(false);
              }
            }}
            photoUrl={displayfiles}
            allFileType={true}
            allowMultiple={true}
            requestFrom="client"
            entityId={$form.id}
          />
        </div>
      </div>

      <div class="form-group mb-3">
        <label
          for=""
          class="form-label">Links</label
        >
        <div class="d-flex flex-row position-relative align-items-center">
          <div class="position-relative w-100 d-flex">
            <div class="{urlInvalid != '' ? 'error' : ''} w-100 position-relative">
              {#if urlInvalid != ''}
                <label
                  class="formError"
                  for="example-text-input">{urlInvalid}</label
                >
              {/if}
              <input
                type="text"
                class="form-control"
                name="example-text-input"
                placeholder="Enter URL"
                on:change={() => (urlInvalid = '')}
                on:keyup={(event) => {
                  if (event.key == 'Enter') {
                    addUrl();
                  }
                }}
                bind:value={newUrl}
              />
            </div>
            <input
              type="text"
              class="form-control"
              name="example-text-input"
              placeholder="Enter URL Title"
              bind:value={newTitle}
              on:keyup={(event) => {
                if (event.key == 'Enter') {
                  addUrl();
                }
              }}
              style="margin-left:5px"
            />
          </div>
          <div class="link-add-btn text-end">
            <button
              on:click={() => addUrl()}
              class="btn background-blue mb-0 text-white px-4 add-task font-size-12 btn-primary"
            >
              Add
            </button>
          </div>
        </div>
      </div>
      <ul class="filte-upload font-size-13 mb-3 p-0">
        {#each $form.urls as item, key}
          <li class="d-flex flex-row align-items-center mb-1 justify-content-between">
            <div class="d-flex">
              <div>
                <img
                  class="icon-16 me-1"
                  alt=""
                  src="/images/globe.svg"
                />
                <span
                  ><a
                    href={item.url}
                    target="_blank">{item.title.trim() != '' ? item.title : item.url}</a
                  ></span
                >
              </div>
            </div>

            <div style="    width: 100px;text-align: right;">
              <button
                class="btn btn-link px-0 mb-0 shadow-none border-0 font-size-12 color-red bg-transparent text-nowrap"
                on:click={() => removeUrl(key)}
              >
                <img
                  class="icon-16"
                  alt=""
                  src="/images/remove.svg"
                />
              </button>
            </div>
          </li>
        {/each}
      </ul>
    </div>
  </div>
</div>

<style lang="scss">
  .btn-add-icons {
    max-width: 52px !important;
  }
  .link-add-btn {
    width: 100px;
  }
</style>
